var categoryInit = function () {

    $('.select2').select2();

    const slider = document.getElementById('price-filter');

    if(slider){
        noUiSlider.create(slider, {
            start: [
                parseInt(slider.dataset.priceStart) || parseInt(slider.dataset.priceFrom),
                parseInt(slider.dataset.priceEnd) || parseInt(slider.dataset.priceUntil)
            ],
            step: 10,
            connect: true,
            range: {
                'min': parseInt(slider.dataset.priceFrom),
                'max': parseInt(slider.dataset.priceUntil),
            },
            tooltips: false,
        });
        slider.noUiSlider.on('update', function (values) {
            document.querySelector('#price-filter-from').innerHTML = parseInt(values[0]) + slider.dataset.currency;
            document.querySelector('#price-filter-until').innerHTML = parseInt(values[1])  + slider.dataset.currency;

            document.getElementById('price-from').value = parseInt(values[0]);
            document.getElementById('price-until').value = parseInt(values[1]);
        });
    }

};
App.prototype.pageDetector('category-page', categoryInit);
